import SocialProofDetails from "./SocialProofDetails";

export default SocialProofDetails;
